import { render } from "./FooterLayout.vue?vue&type=template&id=7fbf937d&scoped=true"
import script from "./FooterLayout.vue?vue&type=script&lang=js"
export * from "./FooterLayout.vue?vue&type=script&lang=js"

import "./FooterLayout.vue?vue&type=style&index=0&id=7fbf937d&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbf937d"]])

export default __exports__